import { FC } from 'react'
import { sanitizeUrl } from '@/utils'
import styles from './index.module.scss'

export const AffiliateLinkItem: FC = () => {
  return (
    <div className={styles.container}>
      <a href={sanitizeUrl(process.env.NEXT_PUBLIC_GATE_AFFILIATE_URL)} target='_blank' rel='noreferrer'>
        <img src='/images/common/gate_banner.png' alt='Gate affiliate' className={styles.image} />
        <div className={styles.textGroup}>
          <img src='/images/common/service_link_icon.svg' alt='External Link' className={styles.icon} />
          <span className={styles.text}>Promoted</span>
        </div>
      </a>
    </div>
  )
}
